import { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled, { keyframes } from "styled-components";
import SaleBanner from "../../pages/home/components/SaleBanner";
import colors from "../../theme/color/ColorTheme";
import fontSize from "../../theme/fonts/FontTheme";
import AllCategoriesBanner from "../banner/AllCategoriesBanner";
import ContactBanner from "../banner/ContactBanner";
import SearchBanner from "../banner/SearchBanner";
import CartIcon from "../icons/CartIcon";
import SearchIcon from "../icons/SearchIcon";
import UserIcon from "../icons/UserIcon";
import LogoFull from "../logo/LogoFull";

const Wrapper = styled.div`
  height: 75px;
  width: 100%;
`;
const Container = styled.div``;
const TopPart = styled.div`
  padding: 0 20px;
  display: flex;
  align-items: center;
  position: relative;
  height: 75px;
`;

const Logo = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  cursor: pointer;
  @media (max-width: 720px) {
    position: relative;
    transform: translateX(0px);
    left: 10px;
  }
`;

const Options = styled.div`
  display: flex;
  gap: 20px;
  margin-left: auto;
`;

const BottomPart = styled.div`
  height: 55px;
  width: 100vw;
  display: flex;
  justify-content: center;

  align-items: center;
  border-bottom: 1px solid ${colors.border};
  opacity: 1;
  background-color: ${colors.backgroundPrimary};
  ul {
    display: flex;
    gap: 20px;
    padding: 0px;
  }
  li {
    font-size: ${fontSize.s};
    list-style: none;
    height: 55px;
    display: flex;
    align-items: center;
    cursor: pointer;
    &:hover {
      color: ${colors.textMuted};
    }
  }
  @media (max-width: 450px) {
    li {
      font-size: ${fontSize.xs};
    }
    ul {
      gap: 15px;
    }
  }
`;
const Line = styled.div`
  height: 8px;
  background-color: ${colors.black};
`;

const Option = styled.div`
  cursor: pointer;
  h3 {
    font-size: ${fontSize.s};
  }
  display: flex;
  align-items: center;
  gap: 5px;
  transition-duration: 0.4s;
  &:hover {
    transform: translateY(-2px);
    color: ${colors.textMuted};
  }
  @media (max-width: 720px) {
    h3 {
      display: none;
    }
  }
`;
const appear = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;
const Overlay = styled.div`
  height: auto;
  width: 100%;
  background-color: ${colors.backgroundPrimary};
  animation: ${appear} 0.3s;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 25px 50px -12px;
`;
function DesktopNavbar() {
  const [showOverlay, setShowOverlay] = useState(false);
  const [overlayType, setOverlayType] = useState();
  const naviagte = useNavigate();
  return (
    <Wrapper>
      <Container>
        <TopPart>
          <Logo onClick={() => naviagte("/")}>
            <LogoFull />
          </Logo>
          <Options>
            <Option
              onMouseEnter={() => {
                setShowOverlay(true);
                setOverlayType("SEARCH");
              }}
            >
              <SearchIcon />
              <h3>Search</h3>
            </Option>
            <Option
              onClick={() => {
                naviagte("/login");
              }}
            >
              <UserIcon />
              <h3>Account</h3>
            </Option>
            <Option
              onClick={() => {
                naviagte("/cart");
              }}
            >
              <CartIcon />
              <h3>My Cart</h3>
            </Option>
          </Options>
        </TopPart>
        <Line />
        <BottomPart>
          <ul>
            <li
              onMouseEnter={() => {
                setShowOverlay(true);
                setOverlayType("SALE");
              }}
              onMouseLeave={() => {
                setShowOverlay(false);
              }}
            >
              Sale & Discounts
            </li>
            <li
              onMouseEnter={() => {
                setShowOverlay(true);
                setOverlayType("CATEGORY");
              }}
              onMouseLeave={() => {
                setShowOverlay(false);
              }}
            >
              All Categories
            </li>
            <li
              onMouseEnter={() => {
                setShowOverlay(true);
                setOverlayType("CONTACT");
              }}
              onMouseLeave={() => {
                setShowOverlay(false);
              }}
            >
              Contact Us
            </li>
            <li
              onClick={() => {
                window.open(
                  "https://www.google.com/maps/place/Wallet+men’s+wear/@27.7218696,85.3384619,17z/data=!3m1!4b1!4m6!3m5!1s0x39eb1915ecc9a90b:0x4b8edb5ca584f56f!8m2!3d27.7218696!4d85.3384619!16s%2Fg%2F11k4gqcvjr?entry=ttu&g_ep=EgoyMDI1MDkxNy4wIKXMDSoASAFQAw%3D%3D"
                );
              }}
            >
              Locate Store
            </li>
          </ul>
        </BottomPart>
      </Container>
      {showOverlay && (
        <Overlay
          onMouseEnter={() => {
            setShowOverlay(true);
          }}
          onMouseLeave={() => {
            setShowOverlay(false);
          }}
        >
          {overlayType === "SALE" ? (
            <SaleBanner />
          ) : overlayType === "CONTACT" ? (
            <ContactBanner />
          ) : overlayType === "SEARCH" ? (
            <SearchBanner />
          ) : (
            <AllCategoriesBanner />
          )}
        </Overlay>
      )}
    </Wrapper>
  );
}

export default DesktopNavbar;
